import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RadioSelectorComponent} from './radio-selector/radio-selector.component';
import {FormsModule} from "@angular/forms";
import { ModuleItemComponent } from './module-item/module-item.component';
import { ModuleSectionComponent } from './module-section/module-section.component';
import {HttpClientModule} from "@angular/common/http";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {PopoverModule} from "ng2-popover";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        PopoverModule
    ],
    declarations: [RadioSelectorComponent, ModuleItemComponent, ModuleSectionComponent],
    exports: [RadioSelectorComponent, ModuleItemComponent, ModuleSectionComponent],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [],
        }
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/shared.module.ts